import { useSelector } from 'hooks/utils';
import { Organization, selectOrganizationById } from 'store/data/collaborators';

export function useOrganizationById(id?: string): Organization | undefined {
	return useSelector(state => selectOrganizationById(state.data.collaborators, { id }));
}
